export const isHttps = () => window.location.protocol === 'https:';
